import React from 'react'
import {IconButton, Divider, List, ListItem, ListItemText, ListItemSecondaryAction, ListItemAvatar, Avatar, makeStyles} from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import ScheduleIcon from '@material-ui/icons/Schedule'
import MessageIcon from '@material-ui/icons/Message'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxHeight: '36ch',
    overflow: 'auto',
    backgroundColor: theme.palette.background.primary,
  },
  inline: {
    display: 'inline',
  },
}))

export default function MessagesList (props) {
  const classes = useStyles()

  const parseTime = function (date) {
    // const d = new Date(date)
    // const hours = d.getHours()
    // const minutes = d.getMinutes()

    return date// `${hours}:${minutes}`
  }

  const select = function (msg) {
    // console.log('MessageList.select', msg, props)
    if (props.onSelect) {
      props.onSelect(msg)
    }
  }

  const onRemove = function (msg) {
    if (props.onRemove) {
      props.onRemove(msg)
    }
  }

  return (
    <List className={classes.root}>
      {
        props.messages
          .sort((a, b) => a.index - b.index)
          .map(message => {
          let time = message.time

          if (time) {
            time = parseTime(time)
          }
          
          return (
            <React.Fragment key={`${message.index || message.event}`}>
              <ListItem alignItems='flex-start' onClick={() => select(message)} button>
                <ListItemAvatar>
                  <Avatar>
                    {message.index ? message.index : <MessageIcon />}
                  </Avatar>
                </ListItemAvatar>
                {
                  !message.templateId ? (
                    <ListItemText
                      primary={`${(!message.excludePrepend && message.prepend) || ''} ${message.body}`}
                      secondary={<span style={{display: 'flex'}}>
                        {/* <span style={{marginRight: '1em'}}>{message.type === 'message' ? <MessageIcon fontSize="small" /> : <ReplyIcon fontSize="small" />}</span> */}
                        {/* <span style={{marginLeft: '1em', marginRight: '1em'}}>{message.type === 'reply' && (
                          (message.event === 'subscribe' ? <SubscribeIcon fontSize="small" /> : <UnsubscribeIcon fontSize="small" />)
                        )}</span> */}
                        {message.event}
                        <span style={{marginRight: '1em'}}>
                          {
                            time && <span style={{display: 'flex'}}><ScheduleIcon fontSize="small" />&nbsp;{time}</span>
                          }</span>
                      </span>}
                    >
                    </ListItemText>
                  ) : null
                }
                {
                  message.templateId ? (
                    <ListItemText
                      primary={props.whatsAppTemplates.find(t => t.id === message.templateId).message}
                      secondary={<span style={{display: 'flex'}}>
                        <span style={{marginRight: '1em'}}>{message.event}</span>
                        <span style={{marginRight: '1em'}}>{time}</span>
                      </span>}
                    >
                    </ListItemText>
                  ) : null
                }
                <ListItemSecondaryAction>
                  {
                    props.removable && (
                      <IconButton edge="end" aria-label="delete" onClick={() => onRemove(message)} disabled={props.readOnly}>
                        <DeleteIcon />
                      </IconButton>
                    )
                  }
                </ListItemSecondaryAction>
              </ListItem>
              <Divider variant='inset' component='li' />
            </React.Fragment>
          )
        })
      }
    </List>
  )
}